import { lazy, useEffect } from 'react';
import { Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { RouteMap } from '@common/constants/RouteMap';

import { MatchMaker } from '@hub/pages/MatchMaker';

const Details = lazy(() => import('@hub/pages/Details'));
const Offers = lazy(() => import('@hub/pages/Offers'));
const PreApprovedOffers = lazy(() => import('@hub/pages/PreApprovedOffers'));
const TicketApprovedOffers = lazy(() => import('@hub/pages/TicketApprovedOffers'));
const FullFunnelRedirect = lazy(() => import('@hub/pages/FullFunnelRedirect'));

export function Router() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!pathname.includes('/ofertas/')) return;
    const offerSlug = pathname.split('/').pop();
    if (!offerSlug) return;

    return navigate(RouteMap.ProductDetail.replace(':slug', offerSlug));
  }, [pathname]);

  return (
    <>
      <Route path={RouteMap.Offer} element={<Offers />} />
      <Route path={RouteMap.ProductDetail} element={<Details />} />
      <Route path={RouteMap.MatchMaker} element={<MatchMaker />} />
      <Route path={RouteMap.PreApprovedOffers} element={<PreApprovedOffers />} />
      <Route path={RouteMap.TicketApprovedOffers} element={<TicketApprovedOffers />} />
      <Route path={RouteMap.FullFunnelRedirect} element={<FullFunnelRedirect />} />
      <Route path={RouteMap.MyFavorites} element={<Navigate to={RouteMap.Dashboard} />} />
    </>
  );
}
